import styles from "./TypeformPage.module.scss";

export const TypeformPage = ({ typeformId, onTypeformSubmit }) => {
  return (
    <div
      className={styles.TypeformContainer}
      data-tf-widget={typeformId}
      data-tf-on-submit={onTypeformSubmit}
      data-tf-transitive-search-params="utm_source,utm_medium,utm_campaign,utm_content,utm_term,page"
      data-tf-hidden="utm_source,utm_medium,utm_campaign,utm_term,utm_content"
    />
  );
};

export default TypeformPage;
